<template lang="pug">
div
    b-container(fluid='')
        protein-sequence(v-if='proteinData.length !== 0 && sequence.length !== 0' v-bind:sequence='sequence' v-bind:modifications='modifications')
        b-row.mb-3(class="justify-content-between")
            b-col(sm='3' md='4')
                b-form-group.mb-0()
                    b-input-group(size='sm')
                        b-form-input#filter-input(v-model='filter' type='search' placeholder='Type to Search')
                        b-input-group-append
                            b-button(:disabled='!filter' @click="filter = ''") Clear
            b-col(sm='7' md='4')
                b-pagination.my-0(v-model="currentPage"
                    :total-rows='totalRows'
                    :per-page='perPage'
                    last-number
                    align='fill'
                    size='sm')
        b-row
            b-col
                p Total {{ currentPage*perPage }}/{{ totalRows }} results
        b-row
            b-table(hover='' 
                v-if='modifications.length !== 0'
                :items='modifications' :fields='fields'
                :filter='filter'
                :filter-included-fields='filterOn'
                @filtered="onFiltered"
                :per-page="perPage"
                :current-page="currentPage")

</template>

<script>
import axios from 'axios'
import ProteinSequence from './ProteinSequence'

export default {
    name: 'Summary',
    components: {
        // MolecularStructure,
        ProteinSequence
    },
    data() {
        return {
            fastaFileContent: '',
            proteinData: [],
            sequence: '',
            chain: '',
            residueList: '',
            mutationsList: '',
            modifications: [],
            fields: [
                { key: 'uniprotPosition', sortable: true },
                { key: 'modifiedResidue', sortable: true },
                { key: 'source', sortable: true },
                { key: 'evidence', sortable: true },
                { key: 'unimodModificationName', sortable: true },
                { key: 'unimodId', sortable: true },
                { key: 'modificationType', sortable: true }
            ],
            proteinId: null,
            filter: null,
            filterOn: [],
            currentPage: 1,
            perPage: 100,
            totalRows: null
        }
    },
    props: {
        info: {} // TODO this should not come from props but set to state in vuex maybe
    },
    created: function() {
        this.fetchFastaFile().then(response => {
            this.fastaFileContent = response.data
            this.parseFastaFileContent(this.fastaFileContent)
        })
    },
    beforeMount: function() {
        console.log('beforeMount')
    },
    mounted: function() {
        console.log('mounted')
        if (this.info !== undefined) {
            this.proteinData = this.info
        }
    },
    methods: {
        async fetchProteinData() {
            const apiBaseUrl = '/scop3ptm/api/protein'
            const response = await axios.get(apiBaseUrl, {
                params: { protein: this.$route.params.protein }
            })
            console.log('protein', response)
            this.proteinData = response.data
            this.$store.commit('setProteinId', response.data.proteins[0].id)
            this.modifications = response.data.proteinMods
            this.totalRows = this.modifications.length
        },
        async fetchFastaFile() {
            const uniProtBaseUrl = 'https://rest.uniprot.org/uniprotkb/'
            let response = ''
            // TODO this is not very good but does the job
            if (this.info === undefined) {
                await this.fetchProteinData()
                console.log('if info empty accession', this.proteinData.proteins[0].accession)
                response = await axios.get(
                    uniProtBaseUrl +
                        this.proteinData.proteins[0].accession +
                        '.fasta'
                )
            } else {
                console.log('if info not empty accession', this.proteinData.proteins[0].accession)
                response = await axios.get(
                    uniProtBaseUrl + this.info.accession + '.fasta'
                )
            }
            return response
        },
        parseFastaFileContent(fileContent) {
            var lines = fileContent.split('\n')
            for (var i = 0; i < lines.length; i++) {
                if (!lines[i].startsWith('>')) {
                    this.sequence += lines[i]
                }
            }
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length
            this.currentPage = 1
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
    font-weight: normal;
}
ul {
    list-style-type: none;
    padding: 0;
}
li {
    display: inline-block;
    margin: 0 10px;
}
a {
    color: #42b983;
}
</style>
